import $ from 'jquery';

export default function edvBlockCounterExt() {
    let done = false;

    function isElementInView(element) {

            let elementTop = $(element).offset().top;
            let elementBottom = elementTop + $(element).outerHeight();

            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;


    }

    function animateCounters() {
        $('.counter-item-number-ext').each(function() {
        let originalText = $(this).text().replace(',', '.');
        let targetNumber = parseFloat(originalText);
        let isDecimal = originalText.includes('.');
        let duration = 4000;
        let frameRate = 24;
        let frames = (duration / 1000) * frameRate;
        let step = targetNumber / frames;
        let currentNumber = 0;

        let interval = setInterval(() => {
            currentNumber += step;
            if(currentNumber >= targetNumber){
                currentNumber = targetNumber;
                clearInterval(interval);
            }


            let displayNumber;
            if (isDecimal) {
                let decimalPlaces = originalText.split('.')[1]?.length || 2;
                displayNumber = currentNumber.toFixed(decimalPlaces).replace('.', ',');
            } else {
                displayNumber = Math.round(currentNumber).toString();
            }
            $(this).text(displayNumber);
        }, 1000 / frameRate);

    });
    }

    $(window).on('scroll', function() {
        if($('.main-counter-module-ext').length > 0) {
            if (!done && isElementInView($('.main-counter-module-ext'))) {
                animateCounters();
                done = true;
            }
        }

    });
}